import { gql } from "@apollo/client";
export const CREATE_USER = gql`
mutation CreateUser($user_input: CreateUserInput) {
    createUser(user_input: $user_input) {
        error {
            field
            message
            code
        }
        data {
            user {
                id
                email
                name
                mobile_no
                status
                created_at
                updated_at
                user_identifier
                roles {
                    id
                    name
                    description
                    permissions {
                        id
                        role_id
                        created_at
                        updated_at
                        action {
                            created_at
                            updated_at
                            id
                            name
                            action
                            resource {
                                name
                                menu
                                display
                                created_at
                                updated_at
                                id
                                module {
                                    name
                                    menu
                                    display
                                    created_at
                                    updated_at
                                    id
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

`;
export const UPDATE_USER = gql`
  mutation UpdateSingleUserDataById($input: UpdateSingleAuthDataInput!, $user_id: UUID!) {
    updateSingleUserDataById(input: $input, user_id: $user_id) {
      data {
            user {
                updated_at
                user_identifier
                name
                email
                id
                mobile_no
                status
                created_at
                roles {
                    id
                    name
                    description
                    permissions {
                        id
                        role_id
                        created_at
                        updated_at
                        action {
                            action
                            created_at
                            updated_at
                            id
                            name
                            resource {
                                display
                                created_at
                                updated_at
                                id
                                name
                                menu
                                module {
                                    display
                                    created_at
                                    updated_at
                                    id
                                    name
                                    menu
                                }
                            }
                        }
                    }
                }
            }
        }
        error {
            message
            code
            field
        }
    }
  }
`;

export const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($input: UpdatePasswordInput!) {
    updatePassword(input: $input) {
      data {
        message
      }
      error {
        code
        field
        message
      }
    }
  }
`;
export const RESET_PASSWORD = gql`
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      data {
        message
      }
      error {
        code
        field
        message
      }
    }
  }
`;

export const UPDATE_USER_ROLE = gql`
mutation UpdateUserRoles($role_ids: [UUID], $user_id: UUID!) {
    updateUserRoles(user_id: $user_id, role_ids: $role_ids) {
        error {
            message
            code
            field
        }
        data {
            user {
                user_identifier
                updated_at
                created_at
                name
                mobile_no
                email
                status
                id
                roles {
                    name
                    description
                    id
                    permissions {
                        created_at
                        updated_at
                        id
                        role_id
                        action {
                            updated_at
                            id
                            name
                            action
                            created_at
                            resource {
                                id
                                name
                                menu
                                display
                                created_at
                                updated_at
                            }
                        }
                    }
                }
            }
        }
    }
}

`;
